import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import sequencer from './sequencer'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);


class Contact extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0
    


    this.ref = {
      contact: null
    }

  }

  mount() {

     
         ScrollTrigger.create({
             trigger: this.element,
             start: "top bottom",
             id: "trigger1",
             onEnter: ({
                 progress,
                 direction,
                 isActive
             }) => {
                 this.body[0].classList.add("has-footer")
             },
             onLeaveBack: ({
                 progress,
                 direction,
                 isActive
             }) => {
                this.body[0].classList.remove("has-footer")
             }
         });
 
         
}



  unmount() {


        ScrollTrigger.getById("trigger1").kill();

  }


}

module.exports = Contact
